/**
 * @desc 供需匹配报表分页查询
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.demandOrder.supplyDemandMatchReport.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/supplyDemand/matchReport/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
